export default class MockAPI {
  constructor() {
    this.token = null;
    this.mockUser = {
      nickname: 'Test User',
      yearOfBirth: 1986,
      sex: 'female',
      email: 'test@example.com',
      acceptedContactUsageVersion: 1,
      password: 'coolpassword',
    };
  }

  fetchUserDetails() {
    return new Promise((resolve) => {
      const response = {
        body: this.mockUser,
      };

      if (this.token === 'valid-token') {
        setTimeout(() => {
          resolve({ status: 'success', res: response, err: null });
        }, 200);
      } else {
        resolve({ status: 'unauthorized', res: null, err: 'Unauthorized' });
      }
    });
  }

  login(email, password) {
    return new Promise((resolve) => {
      const response = {
        body: { access_token: 'valid-token' },
      };

      if (email === this.mockUser.email && password === this.mockUser.password) {
        resolve({ status: 'success', res: response, err: null });
      } else {
        resolve({ status: 'unauthorized', res: null, err: 'Unauthorized' });
      }
    });
  }

  updateUser(attrs, callback) {
    const newUser = Object.assign({}, this.mockUser, attrs);
    const response = {
      body: { ...newUser },
    };

    callback({ status: 'success', res: response, err: null });
  }

  updateEmail(email, callback) {
    callback({ status: 'success', res: null, err: null });
  }

  deleteUser(callback) {
    callback({ status: 'success', res: null, err: null });
  }

  signUp(userDetails, callback) {
    const response = {
      body: {
        status: 'success',
        token: 'verification-token',
      },
    };

    callback({ status: 'success', res: response, err: null });
  }

  resetPasswordRequest(email, callback) {
    const response = { body: {} };
    callback({ status: 'success', res: response, err: null });
  }

  dataImportDate(callback) {
    const response = { body: {} };
    callback({ status: 'success', res: response, err: null });
  }

}



// WEBPACK FOOTER //
// ./src/helper/mockApi.js